var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"green"}}):_c('div',{attrs:{"id":"paypal-button-container"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }